
	import { Observer } from 'mobx-vue';
	import { Component, Prop, PropSync } from 'vue-property-decorator';
	import PrescriptionItem from '@/components/new-prescription/prescription-items/PrescriptionItem.vue';
	import PrescriptionItemWrapper from '@/components/new-prescription/prescription-items/PrescriptionItemWrapper.vue';

	@Observer
	@Component({
		components: { PrescriptionItemWrapper }
	})
	export default class PrescriptionItemSelectLR extends PrescriptionItem {
		@PropSync('inputSelectLeft', { required: true }) inputSelectValueL!: string;
		@PropSync('inputSelectRight', { required: true }) inputSelectValueR!: string;
		@Prop({
			required: false
		})
		sideDisabled!: { left: boolean; right: boolean };
		@Prop({ required: true }) LR!: {};
	}
